import React from 'react';
import PageTemplate from '../components/Layout/PageTemplate/PageTemplate';
import CommonList from '../views/CommonTableView';
const NatureOfExpensePage = () => {
    return (
        <PageTemplate>
           <CommonList page={"nature_of_expense"}/>
        </PageTemplate>
    );
};

export default NatureOfExpensePage;

